export default from './root-base';



// WEBPACK FOOTER //
// ./app/containers/root-base/index.js